module.exports = __webpack_public_path__ + "static/media/Brands partner Infographic Mobile - GBR network - 10-06-2024 C.dd96b77c.gif";